import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/modules/auth/stores/authStore'

interface ProtectedRouteProps {
  children: React.ReactNode
}

/**
 * Wraps authenticated-only routes.
 * - If checking auth: shows nothing (avoids flash)
 * - If not authenticated: redirects to login
 * - If authenticated: renders children
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { status, isAuthenticated } = useAuthStore()

  if (status === 'checking') {
    return null
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth/login" replace />
  }

  return <>{children}</>
}
